const stage = {
    preFile:[  //采购-招标- 前期资料
        {id:'1',key:'projectSet',list:[],flag:false,name:'立项文件',},// 立项
        {id:'2',key:'projectBook',list:[],flag:false,name:'项目建议书',},// 项目建议书
        {id:'3',key:'researchReport',list:[],flag:false,name:'可研报告',},// 可研报告
        {id:'4',key:'eiaAppr',list:[],flag:false,name:'环评批复',},// 环评批复：
        {id:'5',key:'proposalBook',list:[],flag:false,name:'选址意见书',},// 选址意见书
        {id:'6',key:'allocateBook',list:[],flag:false,name:'土地划拨书',},// 土地划拨书
        {id:'7',key:'landCertificate',list:[],flag:false,name:'土地证',},// 土地证：
        {id:'8',key:'planMap',list:[],flag:false,name:'规划总平图审批',},// 规划总平图审批：
        {id:'9',key:'constructionDrawings',list:[],flag:false,name:'定稿施工图纸',},// 定稿施工图纸
        {id:'10',key:'drawingAppr',list:[],flag:false,name:'项目图审查意见及回复审图合格证',},// 项目图审查意见及回复审图合格证：
        {id:'11',key:'fireAppr',list:[],flag:false,name:'消防设计审查意见或批准文件',},// 消防设计审查意见或批准文件：
        {id:'12',key:'defenceAppr',list:[],flag:false,name:'人防设计审查意见或批准文件',},// 人防设计审查意见或批准文件：
        {id:'13',key:'landUse',list:[],flag:false,name:'用地规划许可证',},// 用地规划许可证：
        {id:'14',key:'buildEngin',list:[],flag:false,name:'建设工程规划许可证',},// 建设工程规划许可证：
        {id:'15',key:'otherFile',list:[],flag:false,name:'其他',},// 其他：

        // {id:'3',key:'riskReport',list:[],flag:false,name:'项目风险评估报告：',},// 项目风险评估报告
        // {id:'8',key:'scheme',list:[],flag:false,name:'方案概算及复批：',},// 方案概算及复批：
        // {id:'10',key:'fireMap',list:[],flag:false,name:'消防总平图审批：',},// 消防总平图审批：
        // {id:'11',key:'drawing',list:[],flag:false,name:'全套招标项目图：',},// 全套招标项目图：
        
        // {id:'19',key:'remarks',list:[],flag:false,name:'备注信息：',},// 备注信息：
    ],
    
}
export default stage